// extracted by mini-css-extract-plugin
export default {"filters":"Filters_filters__C5Rfz","placeHolderShimmer":"Filters_placeHolderShimmer__CBUzU"};